import React from 'react'

export const ConditionalWrapper = ({ hasWrapper, children, Wrapper }) => {
  return hasWrapper ? <Wrapper>{children}</Wrapper> : <>{children}</>
}